import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import ToggleNoLabel from '../ToggleNoLabel';

const ToggleCell = ({
  checked,
  title,
  label,
  className,
  disabled,
  onClick,
}) => (
  <Table.Cell collapsing className={clsx('aridhia-toggle-cell', className)} title={title}>
    <ToggleNoLabel label={label} onClick={onClick} disabled={disabled} className={className} checked={checked} />
  </Table.Cell>
);

export default ToggleCell;
